import React from 'react';
import { Link } from 'react-router-dom'; // Importa Link para navegación
import  logo  from '../../assets/img/Logo.png';


const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow-sm px-5 py-3 py-lg-0">
      <Link to="/" className="navbar-logo">
        <img src={logo} alt="Logo" />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto py-0">
          <Link to="/about" className="nav-item nav-link">
            Sobre Lash
          </Link>
          <Link to="/services" className="nav-item nav-link">
            Servicios
          </Link>
          <div className="nav-item dropdown">
           
            <div className="dropdown-menu m-0">
              <Link to="/pricing" className="dropdown-item">
                Planes de Precios
              </Link>
              <Link to="/team" className="dropdown-item">
                Nosotras
              </Link>
              <Link to="/testimonials" className="dropdown-item">
                Testimonios
              </Link>
              <Link to="/appointment" className="dropdown-item">
                Agendá tu turno
              </Link>
            </div>
          </div>
          <Link to="/contact" className="nav-item nav-link">
            Contacto
          </Link>
        </div>
        
        <Link to="/appointment" className="btn btn-primary py-2 px-4 ms-3">
          Agendá tu turno
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
